import { observer } from 'mobx-react';
import Modal from '../../../../../../Modal';
import InviteParticipantStore from '../../Store';
import { Inviting, Submitting } from '../../Types';
import Body from './Body';
import Header from './Header';

export interface Props {
  store: InviteParticipantStore;
  state: Inviting | Submitting;
}

export const resetModal = (store: InviteParticipantStore) => {
  store.modalStore.close();
  store.getLicenseInformation();
};

function InviteModal({ store, state }: Props) {
  switch (store.modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={() => resetModal(store)}
          title={<Header />}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          modalWidth="w-2/5"
        >
          <Body store={store} state={state} />
        </Modal>
      );
  }
}

export default observer(InviteModal);
